<template>
  <div>
    <div class="align-items-center mb-1 d-flex flex-row justify-content-between">
      <div
        id="summary-title-order-amount-ideal"
        data-testid="summary-title-order-amount-ideal"
        class="font-14 text-placeholder"
      >
        {{ $t('payment.airWallex.labelOrderAmount') }}:
      </div>
      <strong
        id="summary-ideal-order-amount"
        data-testid="summary-ideal-order-amount"
      >
        {{ amount }} USD
      </strong>
    </div>

    <div class="align-items-center mb-1 d-flex flex-row justify-content-between">
      <div
        id="summany-ideal-title-payment-method"
        data-testid="summany-ideal-title-payment-method"
        class="font-14 text-placeholder"
      >
        {{ $t('addFundPage.creditCardPayment.textPaymentMethod') }}:
      </div>

      <strong
        id="summary-ideal-method"
        data-testid="summary-ideal-method"
        class="font-14 text-primary"
      >
        <img
          :src="idealLogo"
          height="16px"
          alt="iDEAL"
          style="margin-right: 5px"
        >
        iDEAL
      </strong>
    </div>

    <div class="align-items-center mb-1 d-flex flex-row justify-content-between">
      <div
        id="summany-ideal-title-account-holder-name"
        data-testid="summany-ideal-title-account-holder-name"
        class="font-14 text-placeholder"
      >
        {{ $t('setupCost.accountHolderName') }}:
      </div>

      <strong
        id="summary-ideal-account-holder-name"
        data-testid="summary-ideal-account-holder-name"
        class="font-14 text-primary"
      >
        {{ accountHolderName }}
      </strong>
    </div>

    <div class="align-items-center mb-1 d-flex flex-row justify-content-between">
      <div
        id="summany-ideal-title-verified-name"
        data-testid="summany-ideal-title-verified-name"
        class="font-14 text-placeholder"
      >
        {{ $t('setupCost.verifiedName', {method: 'iDEAL'}) }}:
      </div>

      <strong
        id="summary-ideal-verified-name"
        data-testid="summary-ideal-verified-name"
        class="font-14 text-primary"
      >
        {{ verifiedName }}
      </strong>
    </div>

    <div class="align-items-center mb-1 d-flex flex-row justify-content-between">
      <div
        id="summany-ideal-title-bank-name"
        data-testid="summany-ideal-title-bank-name"
        class="font-14 text-placeholder"
      >
        {{ $t('setupCost.idealBank', {method: 'iDEAL'}) }}:
      </div>

      <strong
        id="summary-ideal-bank-name"
        data-testid="summary-ideal-bank-name"
        class="font-14 text-primary"
      >
        {{ bankName }}
      </strong>
    </div>

    <div
      v-if="serviceCharge"
      class="d-flex align-items-center flex-row justify-content-between mb-1"
    >
      <div
        id="summary-ideal-title-service-fee"
        data-testid="summary-ideal-title-service-fee"
        class="font-14 text-placeholder"
      >
        {{ $t('payment.balanceTransactionsTable.textServiceCharge') }}:
      </div>
      <strong
        id="summary-ideal-current-service-charge"
        data-testid="summary-ideal-current-service-charge"
        class="text-primary"
      >{{ serviceCharge }} USD</strong>
    </div>

    <div
      v-if="iDEALFee"
      class="d-flex align-items-center justify-content-between mb-1"
    >
      <div
        id="title-ideal-fee"
        data-testid="title-ideal-fee"
        class="font-14 text-placeholder"
      >
        {{ $t('payment.paypal.textPaymentFee', {payment: "iDEAL"}) }}:
      </div>
      <div>
        <div
          v-if="amountValidate"
          class="d-flex align-items-center"
        >
          <strong
            id="current-ideal-fee"
            data-testid="current-ideal-fee"
            class="text-primary"
          >{{ iDEALFee }} USD</strong>
        </div>
        <strong v-else>
          --
        </strong>
      </div>
    </div>

    <div
      v-if="tax"
      class="d-flex align-items-center justify-content-between mb-1"
    >
      <div
        id="title-tax-fee-ideal"
        data-testid="title-tax-fee-ideal"
        class="font-14 text-placeholder"
      >
        {{ $t('payment.balanceTransactionsTable.textTax') }}:
      </div>
      <div>
        <div
          v-if="amountValidate"
          class="d-flex align-items-center"
        >
          <strong
            id="current-tax-fee-ideal"
            data-testid="current-tax-fee-ideal"
            class="text-primary"
          >{{ tax }} USD</strong>
        </div>
        <strong v-else>
          --
        </strong>
      </div>
    </div>

    <div
      v-if="amountTip > 0"
      class="d-flex align-items-center justify-content-between"
    >
      <div
        id="summary-ideal-title-tip-amount"
        data-testid="summary-ideal-title-tip-amount"
        class="font-14 text-placeholder"
      >
        {{ $t('payment.balanceTransactionsTable.textTip') }}:
      </div>
      <strong
        id="summary-ideal-current-tip-amount"
        data-testid="summary-ideal-current-tip-amount"
        class="text-primary"
      >{{ amountTip }} USD</strong>
    </div>

    <hr class="hr-custom">

    <div class="d-flex align-items-center justify-content-between mb-3">
      <div class="font-24 text-placeholder">
        {{ $t('addFundPage.creditCardPayment.textTotalAmount') }}
      </div>
      <strong
        v-if="amountValidate"
        id="amount"
        class="font-24 total-amount"
      >
        {{ totalAmount.toLocaleString('en-US') }} USD
      </strong>
      <strong v-else>
        --
      </strong>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-underscore-dangle,camelcase */
import paymentMixin from '@/mixins/paymentMixin'
import generalConfigsMixin from '@/mixins/generalConfigsMixin'
import numberFormatMixin from '@/mixins/numberFormatMixin'

// plugins
import { createNamespacedHelpers } from 'vuex'

const { mapGetters } = createNamespacedHelpers('payment')
const { mapGetters: mapGettersAuth } = createNamespacedHelpers('auth')

export default {

  mixins: [paymentMixin, generalConfigsMixin, numberFormatMixin],

  props: {
    listTransaction: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      amount: Number(this.$route.query.amount) || '',
      bankTransferAmount: this.$route.query.bankTransferAmount || '',
      paymentMethod: this.$route.query.paymentMethod || '',
      transactionId: this.$route.query.transactionId || '',

      amountTip: 0,
      totalAmount: 0,
      iDEALFee: 0,
      tax: 0,
      serviceCharge: 0,
      accountHolderName: '',
      bankName: '',
      verifiedName: '',
    }
  },

  computed: {
    ...mapGetters(['listBusinessAccountHistoryLimit']),
    ...mapGettersAuth(['user', 'generalConfigs']),

    amountValidate() {
      return !!(this.amount >= this.minTopUp && this.amount <= this.maxAmount)
    },

    maxAmount() {
      return 100000
    },

    idealLogo() {
      // eslint-disable-next-line global-require
      return require('@/assets/images/pages/payment/ic-ideal.svg')
    },
  },

  watch: {
    listBusinessAccountHistoryLimit: {
      handler(transactions) {
        if (transactions.paging.total > 0) {
          this.historyTransaction = transactions.content.find(transaction => transaction._id === this.transactionId)

          this.amountTip = this.historyTransaction?.payload?.tipAMAmount || 0
          this.serviceCharge = this.amountFormat(this.historyTransaction?.payload?.serviceCharge) || 0
          this.tax = this.amountFormat(this.historyTransaction?.payload?.taxCharge) || 0
          this.iDEALFee = this.amountFormat(this.historyTransaction?.payload?.paymentGateCharge) || 0
          this.accountHolderName = this.historyTransaction?.payload?.accountHolderName
          this.bankName = this.convertIdealBank(this.historyTransaction?.payload?.bankName)
          this.verifiedName = this.historyTransaction?.payload?.payerName

          this.totalAmount = this.historyTransaction?.payload?.bankTransferAmount
        }
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.summary-container {
  padding: 20px;
  background-color: #F5F5F7;
  // border: 1px solid rgba(22, 33, 62, 0.1);
  border-radius: 16px;

  .title-summary{
    margin-bottom: 21px;
  }
}
.transfer {
  max-width: 125px;
}

.total-amount{
  color: #00A9DE;
}
</style>
